import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';
import { selectors } from '~/store/state-selectors';
import { useStoreActions, useStoreStatic } from '~/store/store-context';
import { useOnMount } from './useOnMount';
export function useManageLocationStack(param) {
    let { initialLocations } = param;
    const { navigator } = useContext(UNSAFE_NavigationContext);
    const { setLocationStack } = useStoreActions();
    const { getState } = useStoreStatic();
    useOnMount(()=>{
        setLocationStack(initialLocations);
    });
    useEffect(()=>{
        // WHY: subscribe to the navigator's history.listen (fires on every PUSH/POP/REPLACE with the
        // action) — the v6 useNavigationType doesn't reflect a POP that doesn't change the location.
        // eslint-disable-next-line no-restricted-syntax
        const history = navigator;
        const unlisten = history.listen((first, second)=>{
            // WHY: history@4 (tests/MemoryRouter) emits (location, action); prod ~/history is bridged to v5's single {location, action}.
            const { location, action } = second !== undefined ? {
                location: first,
                action: second
            } : first;
            const currentLocationStack = selectors.locationStack(getState());
            switch(action){
                case 'PUSH':
                    setLocationStack([
                        ...currentLocationStack,
                        location
                    ]);
                    break;
                case 'REPLACE':
                    setLocationStack([
                        ...currentLocationStack.slice(0, -1),
                        location
                    ]);
                    break;
                case 'POP':
                    setLocationStack(currentLocationStack.slice(0, -1));
                    break;
            }
        });
        return unlisten;
    }, [
        navigator
    ]);
}
